/* src/app/modules/taxes/model-182/model-182-declarado-dialog/model-182-declarado-dialog.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.m182d-header-text {
  min-width: 0;
  padding-right: 32px;
}
.m182d-fs {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.m182d-vistas {
  display: flex;
  gap: 4px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--cf-border);
}
.m182d-vista {
  padding: 8px 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: none;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cf-text-muted);
  cursor: pointer;
}
.m182d-vista--activa {
  color: var(--cf-text);
  border-bottom-color: var(--cf-brand);
}
.m182d-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px 14px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-bg);
}
.m182d-subbox {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px 12px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
}
.m182d-box__title {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--cf-brand-dark);
}
.m182d-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 6px 12px;
  align-items: end;
}
.m182d-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.m182d-field ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.m182d-fila {
  align-self: center;
  font-size: 13px;
  color: var(--cf-text);
}
.m182d-aviso {
  color: #b45309;
}
.m182d-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px 14px;
  border: 1px solid #fecaca;
  border-left: 4px solid var(--cf-error);
  border-radius: var(--cf-radius);
  background: #fef2f2;
  font-size: 13px;
  color: var(--cf-text);
}
.m182d-alert mat-icon {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--cf-error);
}
@media (max-width: 768px) {
  .m182d-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .m182d-grid > * {
    grid-column: span 1 !important;
  }
}
/*# sourceMappingURL=model-182-declarado-dialog.component.css.map */
